import React from 'react'
import PropTypes from 'prop-types'

import AdUnavailable from 'components/AdUnavailable'

import * as S from './styles'

const AdWarnings = ({ children }) => (
  <S.Container id="adWarning" data-test="adWarning">
    <AdUnavailable />

    {!!children && <S.Children>{children}</S.Children>}
  </S.Container>
)

AdWarnings.defaultProps = {
  children: null,
}

AdWarnings.propTypes = {
  children: PropTypes.node,
}

export default AdWarnings
